import React from "react";
import "./BigCard.scss";
import Card from "react-bootstrap/Card";
import StarRating from './StarRating';
import BookmarkCoffee from './BookmarkCoffee';
import CoffeeAvailability from './CoffeeAvailability.js';
import Badge from "react-bootstrap/Badge";
import Icons from "./Icons.js"
import { useHistory } from "../util/router.js";


function BigCard(props) {
  const history = useHistory();
  console.log("BigCard has rendered")
  const { coffee: {
    // coffeeName,
    coffeeProductUrl,
    coffeeCountry,
    coffeeRegion,
    coffeeCompany,
    tastingNotes,
    coffeeFlavor,
    coffeeType,
    coffeeReviewAvg,
    coffeeReviewsNumTotal,
    coffeeRatingTotalAdj,
    coffeeImgUrl,
    coffeeCultivar,
    coffeeProcess,
    coffeeFarm,
    coffeeProducer,
    coffeeElevation,
    coffeeHarvest,
    coffeeAvailability,
    coffeeAvailabilityVote,
    coffeePrice,
    coffeeBagSize,
    roasterLocation,
    coffeeId,
    growingRegion,
    }} = props;
    
    return (

      <Card border="white" className="w-100">
      <Card.Img src={coffeeImgUrl} alt={coffeeCompany} onClick={() => history.goBack()} />
      <Card.Body className="pt-0">
        <Card.Title>{coffeeRegion && `${coffeeRegion}, `} {coffeeCountry} <span className="float-right"><BookmarkCoffee {...props} /></span> </Card.Title>
        {(coffeeRatingTotalAdj > 0) ? 
          <Card.Subtitle className="mb-2">{(coffeeReviewAvg).toFixed(1)} <span className="text-muted"> | {coffeeReviewsNumTotal} </span> </Card.Subtitle> 
          : 
          <Card.Subtitle className="mb-2 text-muted">New</Card.Subtitle>}  
        <span className="mt-1"><a href={coffeeProductUrl}>{coffeeCompany}</a><span className="float-right"><StarRating {...props} /></span></span>
        <hr className="mt-2" style={{ backgroundColor: '#606c38', height: '3px'}} />
        <Card.Text>{(coffeeType).join(" | ")} <Badge variant="outline-primary">{coffeeCultivar}</Badge> </Card.Text>       
        
        <Card.Text className="mt-2">{tastingNotes}</Card.Text>        

        <Card.Text>${coffeePrice} <span className="text-muted"> | {coffeeBagSize}g ({parseFloat((coffeeBagSize*0.03527396198).toFixed(1))}oz)</span>{growingRegion && <span className={`${growingRegion} float-right`}><Icons size='4.5em' name={growingRegion} /></span>}</Card.Text>
        {(coffeeBagSize !== 340) && <Card.Text> ${parseFloat((340/coffeeBagSize*coffeePrice).toFixed(2))} <span className="text-muted"> | 340g (12oz)</span></Card.Text>}
        {coffeePrice && <Card.Text>${parseFloat(20/coffeeBagSize*coffeePrice).toFixed(2)} <span className="text-muted"> | 20g</span> </Card.Text>}
        <hr style={{ backgroundColor: '#c5a880', height: '3px'}} />

        {coffeeCultivar && <Card.Text><span className="text-muted">Cultivar</span> {coffeeCultivar}</Card.Text>}
        {coffeeProcess && <Card.Text><span className="text-muted">Process</span> {coffeeProcess}</Card.Text>}
        {(coffeeElevation > 0) && <Card.Text><span className="text-muted">Altitude</span> {coffeeElevation} meters ({(coffeeElevation*3.28084).toFixed(0)} feet)</Card.Text>}
        {coffeeHarvest && <Card.Text><span className="text-muted">Harvest</span> {coffeeHarvest}</Card.Text>}
        {roasterLocation && <Card.Text>
                              <span className="text-muted">Roaster Location </span>
                                <a 
                                  href={`https://www.google.com/maps/search/?api=1&query=${coffeeCompany}+coffee+${roasterLocation}`}>
                                    {roasterLocation}
                              </a>
                            </Card.Text>}
        {coffeeFarm && <Card.Text><span className="text-muted">Farm</span> {coffeeFarm}</Card.Text>}
        {coffeeProducer && <Card.Text><span className="text-muted">Producer</span> {coffeeProducer} </Card.Text>}
        <hr style={{ backgroundColor: '#606c38', height: '3px'}} />
        <Card.Text>{coffeeAvailability}</Card.Text>
        <CoffeeAvailability coffeeId={coffeeId} coffeeAvailabilityVote={coffeeAvailabilityVote}  />
        <Card.Text className="mt-4 mb-0 text-center"><Badge variant="light">{coffeeFlavor.join(' | ')}</Badge></Card.Text>      
      </Card.Body>
    </Card>        
    
    );
  }

export default BigCard;

// {/* <>
            
// <Card border="white" className="w-100">
//   <Link to={`/c/${coffeeId}`}><Card.Img className="" variant="" src={coffeeImgUrl} alt={coffeeCompany}/></Link>
//   <Card.Body>
//     <Link to={`/c/${coffeeId}`}><Card.Title>{coffeeRegion}, {coffeeCountry}</Card.Title></Link>
//     {(coffeeRatingTotalAdj > 0) ? 
//       <Card.Subtitle className="my-1">{(coffeeReviewAvg).toFixed(1)} <span className="text-muted"> | {coffeeReviewsNumTotal} </span> </Card.Subtitle> 
//       : 
//       <Card.Subtitle className="my-1 text-muted">New</Card.Subtitle>}  
//     <Card.Text><a href={coffeeProductUrl}>{coffeeCompany}</a></Card.Text>
//     <hr style={{ backgroundColor: '#606c38', height: '3px'}} />     

  
    
//         <Card.Text>{tastingNotes}</Card.Text>
//         <ListGroup className="list-group-flush">
//           <ListGroupItem>{(coffeeType).join(" | ")} <Badge variant="outline-primary">{coffeeCultivar}</Badge> </ListGroupItem>
//           <ListGroupItem><StarRating {...props} /></ListGroupItem>
//           <ListGroupItem><SaveCoffee {...props} /></ListGroupItem>
//         </ListGroup>
        
//       <ListGroup className="list-group-flush">
//         {coffeeCultivar && <ListGroupItem><GiPlantRoots size={30} color="#606c38" title="Cultivar" /> {coffeeCultivar}</ListGroupItem>}
//         {coffeePrice && <ListGroupItem><GiTwoCoins size={25} color="#dda15e" title="Offered for" /> ${coffeePrice} | {coffeeBagSize}g ({parseFloat((coffeeBagSize*0.03527396198).toFixed(1))}oz)</ListGroupItem>}
//         {(coffeeBagSize !== 340) && <ListGroupItem><FaBalanceScaleLeft size={25} color="704F38" title="Price Per 340 grams" /> ${parseFloat((340/coffeeBagSize*coffeePrice).toFixed(2))} per 340g (12oz)</ListGroupItem>}
//         {coffeePrice && <ListGroupItem><AiOutlineCoffee size={25} /> ${parseFloat(20/coffeeBagSize*coffeePrice).toFixed(2)} per 20g</ListGroupItem>}
//         {coffeeProcess && <ListGroupItem><GiManualMeatGrinder size={25} color="#6a040f" title="Process" /> {coffeeProcess}</ListGroupItem>}
//         {coffeeElevation && <ListGroupItem><FaMountain size={25} color="#7e8a97" title="Elevation" /> {coffeeElevation} meters ({(coffeeElevation*3.28084).toFixed(0)} feet)</ListGroupItem>}
//         {coffeeHarvest && <ListGroupItem><IoIosBasket size={25} color="#cf7500" title="Harvest Date" /> {coffeeHarvest}</ListGroupItem>}
//         {roasterLocation && <ListGroupItem><FaMapMarked size={25} color="#f0a500" title="Roaster Location" /> {roasterLocation}</ListGroupItem>}
//         {coffeeFarm && <ListGroupItem><GiFarmer size={25} color="#cf7500" title="Farm" /> {coffeeFarm}</ListGroupItem>}
//         {coffeeProducer && <ListGroupItem><GiKitchenScale size={25} color="#1a1c20" title="Producer" /> {coffeeProducer} </ListGroupItem>}
//         <ListGroupItem>{coffeeAvailability}</ListGroupItem>
//         <ListGroupItem><CoffeeAvailability coffeeId={coffeeId} coffeeAvailabilityVote={coffeeAvailabilityVote}  /></ListGroupItem>
//       </ListGroup>
//   </Card.Body>


//   <Card.Footer>
//     <Card.Text className="mb-0"><Badge variant="light">{coffeeFlavor.join(' | ')}</Badge></Card.Text>
//   </Card.Footer>

// </Card>
// </> */}

